import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=1d603e87&scoped=true"
import script from "./FollowUp.vue?vue&type=script&lang=js"
export * from "./FollowUp.vue?vue&type=script&lang=js"
import style0 from "./FollowUp.vue?vue&type=style&index=0&id=1d603e87&prod&lang=scss"
import style1 from "./FollowUp.vue?vue&type=style&index=1&id=1d603e87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d603e87",
  null
  
)

export default component.exports